import {Injectable} from '@angular/core';
import {ProjectCategory} from "../models/project-category.model";
import {Subject} from "rxjs";
import {HttpRequestsConfigService} from "./http-requests-config.service";
import {DemokratiewerkstattCategory} from "../models/demokratiewerkstatt.model";


@Injectable({
  providedIn: 'root'
})
export class DemokratiewerkstattCategoryService {
  public demokratiewerkstattCategories: DemokratiewerkstattCategory[] = [];
  public DemokratiewerkstattCategorySubject: Subject<DemokratiewerkstattCategory[]> = new Subject<DemokratiewerkstattCategory[]>();

  constructor(private readonly _httpRequestConfig: HttpRequestsConfigService) {
  }

  public emitDemokratiewerkstattCategorySubject() {
    this.DemokratiewerkstattCategorySubject.next(this.demokratiewerkstattCategories.slice());
  }



  getAllCategorys() {
    this._httpRequestConfig
      .getAll<ProjectCategory>('/demokratiewerkstatt-category')
      .subscribe((response) => {
        this.demokratiewerkstattCategories = (response as any).category;
        this.emitDemokratiewerkstattCategorySubject();
      });
  }

 public getDemokratiewerkstattCategory(id: number) {
    return this._httpRequestConfig.get<DemokratiewerkstattCategory>('/demokratiewerkstatt-category', id);
  }

  createProjectCategory(category: ProjectCategory) {
    return this._httpRequestConfig.post<ProjectCategory>(
      '/demokratiewerkstatt-category/add',
      category
    );
  }

  editProjectCategory(id: number | string, category: DemokratiewerkstattCategory) {
    return this._httpRequestConfig.put<DemokratiewerkstattCategory>(
      '/demokratiewerkstatt-category/update',
      id,
      category
    );
  }

  deleteProjectCategory(id: string | number) {
    return this._httpRequestConfig.delete<ProjectCategory>(
      '/demokratiewerkstatt-category/delete',
      id
    );
  }

}
